import React from 'react';

export default (
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000"
    height="24"
    width="20"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 24 24"
  >
    <path
      d="M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.6l-9.83 9.83 1.4 1.4L19 6.4V10h2V3h-7z"
      fill="#0066cc"
    />
  </svg>
);
